// WetsuitConstants.js

export const WETSUIT_SPRING_COLD = '6/5mm full suit. Boots, gloves and a hood are a must have for these conditions.';
export const WETSUIT_SPRING_MILD = '5/4 or 5/3mm Full Wetsuit. Boots and gloves are a must. A wetsuit hood is also a good idea.';
export const WETSUIT_SPRING_WARM = '4/3mm Full Wetsuit';

export const WETSUIT_SUMMER_COOL = '3/2mm full wetsuit';
export const WETSUIT_SUMMER_WARM = '1-2mm Shorty Wetsuit';

export const WETSUIT_AUTUMN_COLD = '5/4 or 5/3mm Full Wetsuit. Boots and gloves are a must. A wetsuit hood is also a good idea.';
export const WETSUIT_AUTUMN_MILD = '4/3mm Full Wetsuit';
export const WETSUIT_AUTUMN_WARM = '3/2mm full wetsuit';

export const WETSUIT_WINTER_COLD = '6/5mm full suit. Boots, gloves and a hood are a must have for these conditions.';
export const WETSUIT_WINTER_MILD = '5/4 or 5/3mm Full Wetsuit. Boots and gloves are a must. A wetsuit hood is also a good idea.';

// Translation of wetsuit recommendations to Swedish
export const WETSUIT_SPRING_COLD_SV = '6/5mm hel dräkt. Stövlar, handskar och en huva är ett måste för dessa förhållanden.';
export const WETSUIT_SPRING_MILD_SV = '5/4 eller 5/3mm Full Våtdräkt. Stövlar och handskar är ett måste. En våtdräktsluva är också en bra idé.';
export const WETSUIT_SPRING_WARM_SV = '4/3mm Full Våtdräkt';

export const WETSUIT_SUMMER_COOL_SV = '3/2mm full våtdräkt';
export const WETSUIT_SUMMER_WARM_SV = '1-2mm kort våtdräkt';

export const WETSUIT_AUTUMN_COLD_SV = '5/4 eller 5/3mm Full Våtdräkt. Stövlar och handskar är ett måste. En våtdräktsluva är också en bra idé.';
export const WETSUIT_AUTUMN_MILD_SV = '4/3mm Full Våtdräkt';
export const WETSUIT_AUTUMN_WARM_SV = '3/2mm full våtdräkt';

export const WETSUIT_WINTER_COLD_SV = '6/5mm hel dräkt. Stövlar, handskar och en huva är ett måste för dessa förhållanden.';
export const WETSUIT_WINTER_MILD_SV = '5/4 eller 5/3mm Full Våtdräkt. Stövlar och handskar är ett måste. En våtdräktsluva är också en bra idé.';